/**
 * Copyright IBM Corp. 2022, 2026
 */

import s from './style.module.css'

const PRODUCT_MAP = {
	sentinel: 'Sentinel',
	vault: 'Vault',
	vagrant: 'Vagrant',
	terraform: 'Terraform',
	packer: 'Packer',
	nomad: 'Nomad',
	consul: 'Consul',
	boundary: 'Boundary',
}

interface Badges {
	heading: string
	products: Array<string>
}

export default function CertificationBadges({ heading, products }: Badges) {
	return (
		<div className={s.badges}>
			<h2 className={s.eyebrow}>{heading}</h2>
			<ul className={s.products}>
				{products.map((product) => {
					const badgeFill = product === 'sentinel' ? 'black' : product
					const invertCheckmark = ['vault', 'packer', 'nomad'].includes(product)
					return (
						<li className={s.item} key={product}>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="m12 .625 10 5.682V17.67l-10 5.681-10-5.681V6.306L12 .625Z"
									fill={`var(--${badgeFill})`}
								/>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="m10.106 14.165-2.172-2.171a.946.946 0 1 0-1.339 1.338l2.841 2.841a.945.945 0 0 0 1.34 0l5.959-6.356a.946.946 0 1 0-1.34-1.339l-5.29 5.687Z"
									fill={`var(--${invertCheckmark ? 'black' : 'white'})`}
								/>
							</svg>
							<span className={s.label}>{PRODUCT_MAP[product]}</span>
						</li>
					)
				})}
			</ul>
		</div>
	)
}
